import { useCallback, useEffect } from "react";

import ShyftPassPage from "@/containers/ShyftPassPage";

import { appendHotJarScript, renderMetaData } from "@/utils";

//Redux
import { useAppDispatch, useAppSelector } from "@/hooks";
import * as actions from "@/redux/HealthProgramV1Reducer";
import * as shyftPassActions from "@/redux/ShyftPassReducer";
import { wrapper } from "@/redux/Store";

const slug = "shyftpass";

const ShyftPass = () => {
  const dispatch = useAppDispatch();

  const data = useAppSelector((state) => state.healthProgramV1);

  // FOR HOTJAR TRACKING
  useEffect(() => {
    const isProduction = process.env.NEXT_PUBLIC_SENTRY_ENV === "production";
    const { head, script } = appendHotJarScript(isProduction);

    return () => {
      if (isProduction && head && script) head.removeChild(script);
    };
  }, []);

  const getHealthLandingPageV1 = useCallback(
    () =>
      dispatch(
        actions.getHealthLandingPageV1({ slug, timezone: "Asia/Calcutta" })
      ),
    [dispatch]
  );

  useEffect(() => {
    getHealthLandingPageV1();
  }, [getHealthLandingPageV1]);

  const metaData = {
    siteName: "Shyftpass",
    siteURL: "https://www.betheshyft.com/shyftpass/",
    title:
      "Shyft Pass - Weekend Workouts, Community Mixers, Latest Wellness Products",
    description:
      "Shyft Pass | The best health and wellness membership that provides exclusive access to weekend workouts, community mixers, latest wellness products",
    thumbnail:
      "https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2023-11/shyftpass_meta_image-8fd0ae1bf8fa4c3db2bd4d9e7ba64a81.jpg",
  };

  const metaTags = renderMetaData(metaData);

  return (
    <>
      {metaTags}
      <main id="shyftpass-page">
        <ShyftPassPage data={data} />
      </main>
    </>
  );
};

export default ShyftPass;

export const getServerSideProps = wrapper.getServerSideProps(
  (store) => async () => {
    await store.dispatch(
      actions.getHealthLandingPageV1({ slug, timezone: "Asia/Calcutta" })
    );
    await store.dispatch(shyftPassActions.getShyftPassScheduleData({}));
  }
);
